import { types } from "mobx-state-tree";

const ReasonCode = types.model('ReasonCode', {
  code: types.identifierNumber,
  description: types.string,
});

export default ReasonCode;
